import React from 'react'
import { useTranslation } from 'react-i18next'

import Folder from '@/public/images/folder.svg'

export const AttachedFilesEmpty: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-4 py-20 text-center border border-solid shadow-sm border-gray-light-200 rounded-b-xl">
      <img src={Folder} alt="No attached files" className="w-[54px] h-12" />
      <p className="m-0 font-semibold text-md text-tertiary-900">
        {t('fileUpload.attachedFiles.emptyState')}
      </p>
    </div>
  )
}
